import { useEffect, useRef, useState } from "react"
import { getAllAppUI } from "services/appService";
import AppUIModel from 'models/AppUI'
export const useGetListAppUI = (params) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const paging = useRef({
        pageIndex: 1,
        pageSize: 10,
        totalCount: 10
    })
    const getList = async () => {
        setIsLoading(true);
        try {
            const response = await getAllAppUI(params);
            if(response) {
                setData(response.result.map(el => new AppUIModel(el)));
                paging.current = {
                    pageIndex: response.pageIndex,
                    pageSize: response.pageSize,
                    totalCount: response.totalCount
                }
            }
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getList();
    },[params])

    const reLoadData = () => {
        getList()
    }

    return {data, isLoading, error, paging, reLoadData}
}